import React, { useState } from 'react';
import { CalendarIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../project-create/Urls';
import DataCard from '../profile-edit/DataCard';
import useProjectTags from '../../hooks/useProjectTags';
import TagTypes from '../../constants/TagTypes';
import { PayloadStates } from '@lore/utils';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function Days(props) {
  const { project } = props;
  const { history } = usePageRouter();

  const [timestamp] = useState(new Date().toISOString());

  const projectDays = useProjectTags(project, TagTypes.Day, timestamp);

  let subtitle = '';

  if (projectDays.state === PayloadStates.FETCHING) {
    subtitle = '...';
  } else {
    subtitle = projectDays.data.map(function(projectDay, index) {
      return (
        <div key={index}>
          {projectDay.data.name}
        </div>
      );
    });
  }

  return (
    <DataCard
      title="Days"
      icon={CalendarIcon}
      subtitle={subtitle.length > 0 ? subtitle : '(not provided)'}
      onClick={() => history.push(Urls(project).DAYS)}
    />
  );
};
